const ClusterCarSVG = value => {
    let widthTooltip = 15
    let widthCircle = 57

    for (let i = 0; i < value.toString().length; i++) {
        widthTooltip += 7
        widthCircle += 7
    }

    const heigthTooltip = 20

    const tooltip = `<g filter="url(#filter2_dd_2116_35855)">
    <rect x="37" y="2" width="${widthTooltip}" height="${heigthTooltip}" rx="10" fill="white" shape-rendering="crispEdges"/>
    <text fill="#606A80" xml:space="preserve" style="white-space: pre" font-family="Source Sans Pro" font-size="13" font-weight="600" letter-spacing="0em"><tspan x="43.8242" y="16.6215">${value}</tspan></text>
    <rect x="36.75" y="1.75" width="${widthTooltip}" height="${heigthTooltip}" rx="10.25" stroke="#BAC0CB" stroke-width="0.5" shape-rendering="crispEdges"/>
    </g>`

    return `
    <svg width="${widthCircle}" height="57" viewBox="0 0 ${widthCircle} 57" fill="none" xmlns="http://www.w3.org/2000/svg">
    <g filter="url(#filter0_dd_2116_35855)">
    <rect x="15" y="12" width="32" height="32" rx="16" fill="#364159" fill-opacity="0.9"/>
    <g filter="url(#filter1_dd_2116_35855)">
    <path d="M38.6093 25.5H36.7655L36.2343 24.2188C35.703 22.875 34.4218 22 32.9843 22H29.0155C27.578 22 26.2968 22.875 25.7655 24.2188L25.2343 25.5H23.3905C23.1405 25.5 22.953 25.75 23.0155 25.9688L23.203 26.7188C23.2343 26.9062 23.3905 27 23.578 27H24.203C23.7655 27.375 23.5155 27.9062 23.5155 28.5V30C23.5155 30.5312 23.703 30.9688 24.0155 31.3125V33C24.0155 33.5625 24.453 34 25.0155 34H26.0155C26.5468 34 27.0155 33.5625 27.0155 33V32H35.0155V33C35.0155 33.5625 35.453 34 36.0155 34H37.0155C37.5468 34 38.0155 33.5625 38.0155 33V31.3125C38.2968 30.9688 38.5155 30.5312 38.5155 30V28.5C38.5155 27.9062 38.2343 27.375 37.7968 27H38.453C38.6093 27 38.7655 26.9062 38.7968 26.7188L38.9843 25.9688C39.0468 25.75 38.8593 25.5 38.6093 25.5ZM27.6093 24.9688C27.8593 24.375 28.3905 24 29.0155 24H32.9843C33.6093 24 34.1405 24.375 34.3905 24.9688L35.0155 26.5H27.0155L27.6093 24.9688ZM26.0155 30C25.3905 30 25.0155 29.625 25.0155 29C25.0155 28.4062 25.3905 28 26.0155 28C26.6093 28 27.5155 28.9062 27.5155 29.5C27.5155 30.0938 26.6093 30 26.0155 30ZM36.0155 30C35.3905 30 34.5155 30.0938 34.5155 29.5C34.5155 28.9062 35.3905 28 36.0155 28C36.6093 28 37.0155 28.4062 37.0155 29C37.0155 29.625 36.6093 30 36.0155 30Z" fill="white"/>
    </g>
    <rect x="10" y="7" width="42" height="42" rx="21" stroke="#364159" stroke-opacity="0.4" stroke-width="10"/>
    <circle cx="31" cy="28" r="15.5" stroke="white"/>
    </g>
    ${tooltip}
    <defs>
    <filter id="filter0_dd_2116_35855" x="0" y="1" width="62" height="62" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB">
    <feFlood flood-opacity="0" result="BackgroundImageFix"/>
    <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha"/>
    <feMorphology radius="1" operator="erode" in="SourceAlpha" result="effect1_dropShadow_2116_35855"/>
    <feOffset dy="2"/>
    <feGaussianBlur stdDeviation="2"/>
    <feComposite in2="hardAlpha" operator="out"/>
    <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.06 0"/>
    <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_2116_35855"/>
    <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha"/>
    <feMorphology radius="1" operator="erode" in="SourceAlpha" result="effect2_dropShadow_2116_35855"/>
    <feOffset dy="4"/>
    <feGaussianBlur stdDeviation="3"/>
    <feComposite in2="hardAlpha" operator="out"/>
    <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"/>
    <feBlend mode="normal" in2="effect1_dropShadow_2116_35855" result="effect2_dropShadow_2116_35855"/>
    <feBlend mode="normal" in="SourceGraphic" in2="effect2_dropShadow_2116_35855" result="shape"/>
    </filter>
    <filter id="filter1_dd_2116_35855" x="18.0034" y="21" width="25.9929" height="22" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB">
    <feFlood flood-opacity="0" result="BackgroundImageFix"/>
    <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha"/>
    <feMorphology radius="1" operator="erode" in="SourceAlpha" result="effect1_dropShadow_2116_35855"/>
    <feOffset dy="2"/>
    <feGaussianBlur stdDeviation="2"/>
    <feComposite in2="hardAlpha" operator="out"/>
    <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.06 0"/>
    <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_2116_35855"/>
    <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha"/>
    <feMorphology radius="1" operator="erode" in="SourceAlpha" result="effect2_dropShadow_2116_35855"/>
    <feOffset dy="4"/>
    <feGaussianBlur stdDeviation="3"/>
    <feComposite in2="hardAlpha" operator="out"/>
    <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"/>
    <feBlend mode="normal" in2="effect1_dropShadow_2116_35855" result="effect2_dropShadow_2116_35855"/>
    <feBlend mode="normal" in="SourceGraphic" in2="effect2_dropShadow_2116_35855" result="shape"/>
    </filter>
    <filter id="filter2_dd_2116_35855" x="31.5" y="0.5" width="149" height="31" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB">
    <feFlood flood-opacity="0" result="BackgroundImageFix"/>
    <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha"/>
    <feMorphology radius="1" operator="erode" in="SourceAlpha" result="effect1_dropShadow_2116_35855"/>
    <feOffset dy="2"/>
    <feGaussianBlur stdDeviation="2"/>
    <feComposite in2="hardAlpha" operator="out"/>
    <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.06 0"/>
    <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_2116_35855"/>
    <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha"/>
    <feMorphology radius="1" operator="erode" in="SourceAlpha" result="effect2_dropShadow_2116_35855"/>
    <feOffset dy="4"/>
    <feGaussianBlur stdDeviation="3"/>
    <feComposite in2="hardAlpha" operator="out"/>
    <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"/>
    <feBlend mode="normal" in2="effect1_dropShadow_2116_35855" result="effect2_dropShadow_2116_35855"/>
    <feBlend mode="normal" in="SourceGraphic" in2="effect2_dropShadow_2116_35855" result="shape"/>
    </filter>
    </defs>
    </svg>
    
    `
}

export default ClusterCarSVG
